import { render, staticRenderFns } from "./NewCount.vue?vue&type=template&id=2c35c087&scoped=true"
import script from "./NewCount.vue?vue&type=script&lang=js"
export * from "./NewCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35c087",
  null
  
)

export default component.exports